import { gql } from "@apollo/client";
import { CAR_DETAIL_FRAGMENT } from "../../../common/graphqlQueries/fragments";

export const GET_INVENTORY_STATS = gql`
  query getInventoryStats($filters: [FilterInputType!], $workshopId: String!) {
    getInventoryStats(workshopId: $workshopId, filters: $filters) {
      label
      name
    }
  }
`;


export const GET_REFURB_CAR_LISTING = gql`
  query getRefurbCarListingForInventoryStats(
    $page: Int, 
    $search: String, 
    $orderBy: String,
    $filters: [FilterInputType!],
    $workshopId: String!
  ) {
    getRefurbCarListingForInventoryStats(
      workshopId: $workshopId,
      filters: $filters,
      page: $page, 
      search: $search, 
      orderBy: $orderBy,
    ) {
      data {
        id
        requestSlug
        cgtName
        tat
        idealLiveDate
        isJoblistUnholdableFromWorkshopDashboard
        car {
          ...CarDetail
        }
        isBayLayoutEnabled
        isSparePartsServiceAvailable
        currentPodTechnicianNameAndAssignTime{
          label
        }
        jobList {
          id
        }
        getActiveJoblist {
          id
          isJoblistOnHold
          joblistOnHoldReason
        }
      }
      paginator{
        totalItems
        perPage
        numPages
        currentPage
      }
    }
  }
  ${CAR_DETAIL_FRAGMENT}
`;

export const GET_REFURB_CAR_SLUGS = gql`
  query getRequestBySlugs(
    $slugs: [String!]!, $podValue: String!
  ) {
    getRequestBySlugs(
      slugs:$slugs
      
    ) {
      id
      slug
      remainingParts(podValue:$podValue){
        label
      }  
      nodeItems(podValue:$podValue){
        id
      }
    }
  }
`;

export const GET_POD_LISTING_FOR_WORKSHOP =  gql`
  query getPodListingForWorkshop($workshopId: String!) {
    getPodListingForWorkshop(workshopId: $workshopId) {
      value: podValue
      title: name
      priority
    }
  }
`;

export const GET_INVENTORY_SIZE =  gql`
  query getTotalInventorySize($workshopId: String!) {
    getTotalInventorySize(workshopId: $workshopId)
  }
`;

export const GET_TOTAL_INVENTORY_COUNTS = gql`
  query getInventoryCounts($workshopId: String!) {
    getInventoryCounts(workshopId: $workshopId) {
      totalInventorySize
      totalCardInWaitingForPod
    }
  }
`